import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, Inbox, FileText } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm transition-colors ${
      isActive ? "bg-ink text-bone" : "text-ink-muted hover:bg-ink/5 hover:text-ink"
    }`;

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-bone">
      <div className="grid grid-cols-12 min-h-screen">
        <aside className="col-span-12 md:col-span-3 lg:col-span-2 hairline-b md:border-b-0 md:border-r border-black/10 bg-white/40 backdrop-blur">
          <div className="p-6">
            <Link to="/" className="block">
              <div className="kbd">Dr Tegbir · CMS</div>
              <div className="mt-2 font-serif text-2xl tracking-tightest">Admin</div>
            </Link>
          </div>
          <nav className="p-4 space-y-1">
            <NavLink to="/admin" end className={linkClass} data-testid="admin-nav-dashboard">
              <LayoutDashboard size={16}/> Dashboard
            </NavLink>
            <NavLink to="/admin/leads" className={linkClass} data-testid="admin-nav-leads">
              <Inbox size={16}/> Leads
            </NavLink>
            <NavLink to="/admin/content" className={linkClass} data-testid="admin-nav-content">
              <FileText size={16}/> Content
            </NavLink>
            <NavLink to="/admin/journal" className={linkClass} data-testid="admin-nav-journal">
              <FileText size={16}/> Journal drafts
            </NavLink>
          </nav>
          <div className="p-4 mt-6">
            <div className="kbd">Signed in</div>
            <div className="mt-1 text-sm">{user?.email}</div>
            <button onClick={handleLogout} data-testid="admin-logout" className="mt-4 inline-flex items-center gap-2 text-sm text-ink-muted hover:text-crimson">
              <LogOut size={14}/> Sign out
            </button>
          </div>
        </aside>
        <section className="col-span-12 md:col-span-9 lg:col-span-10 p-6 md:p-10">
          <Outlet/>
        </section>
      </div>
    </div>
  );
}
